import { sanitizeQuery } from '../../../../helpers/sanitizeQueryHelper'
import { AppConfigurationKey } from '../../../../model/enums/appConfigurationKey'
import { ObjectionTableModel } from '../../../../pages/invoicesPage/invoicesPage.Model'
import { LeadRequestModel } from '../../../../pages/leads/leads.model'
import { getAppConfigurationValue } from '../../../../redux'
import AxiosInstance from '../../../http-config'
import { EnumTipoLead } from '../../../oData/enums/enumTipoLead'
import { EnumCommodity } from '../../enums'
import {
  EvaluateLeadRequestModel,
  LeadAnnouncementResponseModel,
  LeadConsumptionQuantityByProfileRequestModel,
  LeadModel,
  LeadQueryModel,
  LeadQueryRequestModel,
  LeadsSearchFilterModel
} from './model/leads'

export const apiGetLeadByID = async (leadID: number): Promise<LeadModel> => {
  const apiSuffixUrl = getAppConfigurationValue(AppConfigurationKey.PrefixEnviromentArgentia)

  return await AxiosInstance.get(`${apiSuffixUrl}/api/Leads(${leadID})`).then(response => {
    if (response.data) {
      return response.data
    }
  })
}

export const apiGetLeads = async (commodity: EnumCommodity): Promise<LeadModel[]> => {
  const apiSuffixUrl = getAppConfigurationValue(AppConfigurationKey.PrefixEnviromentArgentia)

  return await AxiosInstance.get(`${apiSuffixUrl}/api/Leads?commodity=${commodity}`).then(
    response => {
      if (response.data) {
        return response.data
      } else {
        return []
      }
    }
  )
}

export const apiGetLeadsByType = async (
  commodity: EnumCommodity,
  leadType: EnumTipoLead
): Promise<LeadModel[]> => {
  const apiSuffixUrl = getAppConfigurationValue(AppConfigurationKey.PrefixEnviromentArgentia)

  return await AxiosInstance.get(
    `${apiSuffixUrl}/api/Leads/GetLeadsByType?commodity=${commodity}&leadType=${leadType}`
  ).then(response => {
    if (response.data) {
      return response.data
    } else {
      return []
    }
  })
}

export const apiGetLeadsByFilter = async (
  request: LeadsSearchFilterModel
): Promise<LeadModel[]> => {
  const apiSuffixUrl = getAppConfigurationValue(AppConfigurationKey.PrefixEnviromentArgentia)

  // Sanitize TEXT fields to prevent SQL injection (single point of defense)
  const sanitizedRequest: LeadsSearchFilterModel = {
    ...request,
    code: request.code ? sanitizeQuery(request.code, ['-', '_']) : undefined,
    description: request.description ? sanitizeQuery(request.description, [' ']) : undefined
  }

  return await AxiosInstance.post(
    `${apiSuffixUrl}/api/Leads/GetLeadsByFilter`,
    sanitizedRequest
  ).then(response => {
    if (response.data) {
      return response.data
    } else {
      return []
    }
  })
}

export const apiPostLead = async (request: LeadRequestModel): Promise<LeadModel> => {
  const apiSuffixUrl = getAppConfigurationValue(AppConfigurationKey.PrefixEnviromentArgentia)

  return await AxiosInstance.post(`${apiSuffixUrl}/api/Leads`, request).then(response => {
    if (response.data) {
      const data = response.data
      return { ...data, id: data.id ?? data.idLead }
    }
  })
}

export const apiUpdateLead = async (
  request: LeadRequestModel,
  leadId: number
): Promise<LeadModel> => {
  const apiSuffixUrl = getAppConfigurationValue(AppConfigurationKey.PrefixEnviromentArgentia)

  return await AxiosInstance.post(
    `${apiSuffixUrl}/api/Leads(${leadId})/BulkEditLead`,
    request
  ).then(response => {
    if (response.data) {
      return response.data
    }
  })
}

export const apiPostQueryLead = async (
  request: LeadQueryRequestModel
): Promise<LeadQueryModel[]> => {
  const apiSuffixUrl = getAppConfigurationValue(AppConfigurationKey.PrefixEnviromentArgentia)

  return await AxiosInstance.post(`${apiSuffixUrl}/api/Leads/QueryLead`, request).then(response => {
    if (response.data) {
      return response.data
    } else {
      return []
    }
  })
}

export const apiGetLeadAnnouncements = async (
  commodity: EnumCommodity,
  leadType: EnumTipoLead
): Promise<LeadAnnouncementResponseModel[]> => {
  const apiSuffixUrl = getAppConfigurationValue(AppConfigurationKey.PrefixEnviromentArgentia)

  return await AxiosInstance.get(
    `${apiSuffixUrl}/api/Leads/GetLandingAnnouncement?commodity=${commodity}&leadType=${leadType}`
  ).then(response => {
    if (response.data) {
      return response.data
    } else {
      return []
    }
  })
}

export const apiEvaluateLead = async (request: EvaluateLeadRequestModel[]): Promise<any> => {
  const apiSuffixUrl = getAppConfigurationValue(AppConfigurationKey.PrefixEnviromentArgentia)

  return await AxiosInstance.post(`${apiSuffixUrl}/api/Leads/EvaluateLead`, request).then(
    response => {
      if (response.data) {
        return response.data
      }
    }
  )
}

export const apiCreateConsumptionQuantityByProfile = async (
  request: LeadConsumptionQuantityByProfileRequestModel
): Promise<LeadModel> => {
  const apiSuffixUrl = getAppConfigurationValue(AppConfigurationKey.PrefixEnviromentArgentia)

  return await AxiosInstance.post(
    `${apiSuffixUrl}/api/Leads/CreateConsumptionQuantityByProfile`,
    request
  ).then(response => {
    if (response.data) {
      return response.data
    }
  })
}

export const apiGetObjectionsByLeadId = async (
  leadId: number
): Promise<ObjectionTableModel[] | undefined> => {
  const apiSuffixUrl = getAppConfigurationValue(AppConfigurationKey.PrefixEnviromentArgentia)

  return await AxiosInstance.get(`${apiSuffixUrl}/api/Leads/${leadId}/Objections`).then(
    response => {
      if (response.data) {
        return response.data
      } else {
        return []
      }
    }
  )
}

export const apiDeleteLeadByID = async (leadID: number): Promise<LeadModel> => {
  const apiSuffixUrl = getAppConfigurationValue(AppConfigurationKey.PrefixEnviromentArgentia)
  // const apiSuffixUrl = 'https://localhost:59140'
  return await AxiosInstance.delete(`${apiSuffixUrl}/api/Leads(${leadID})`).then(response => {
    if (response.data) {
      return response.data
    }
  })
}
